module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-paypal-express-checkout/index.js
// module id = 843
// module chunks = 0